import { render } from "./AttachmentDocument.vue?vue&type=template&id=4e4f60de"
import script from "./AttachmentDocument.vue?vue&type=script&lang=js"
export * from "./AttachmentDocument.vue?vue&type=script&lang=js"

import "./AttachmentDocument.vue?vue&type=style&index=0&id=4e4f60de&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__